import { LastIdsPaginationModel } from "../../app/data/common/models";
import {
  DriversResponseContentModel,
  PickupLogItem,
  PickupsGroupModel,
  PickupsResponseContentModel,
  ResponseScrollModel
} from "../../app/data/pickup/models";

export default interface PickupAssignmentState {
  requestStarted: boolean;
  fetchPortionStarted: boolean;
  requestCreator: string;
  requestSucceed: boolean;
  requestFailed: boolean;
  requestResponseCode: number;
  requestError: string;
  pickups: (PickupsResponseContentModel | PickupsGroupModel)[];
  pickupsRequest: ResponseScrollModel | null;
  pickupsFetchedAll: boolean;
  drivers: DriversResponseContentModel[];
  driversRequest: ResponseScrollModel | null;
  driversFetchedAll: boolean;
  pickupsLog: PickupLogItem[];
  pickupsLogRequest: {
    page: number,
    last: boolean
  };
  createdGroupId: string;
  loadedPickupAssignmentPages: LastIdsPaginationModel[];
  startDate: string;
  endDate: string;
};

export const initialPickupAssignmentState: PickupAssignmentState = {
  requestStarted: false,
  fetchPortionStarted: false,
  requestCreator: "",
  requestSucceed: false,
  requestFailed: false,
  requestResponseCode: 0,
  requestError: "",
  pickups: [],
  pickupsRequest: null,
  pickupsFetchedAll: false,
  drivers: [],
  driversRequest: null,
  driversFetchedAll: false,
  pickupsLog: [],
  pickupsLogRequest: {
    page: 0,
    last: false
  },
  createdGroupId: "",
  loadedPickupAssignmentPages: [],
  startDate: "",
  endDate: "",
};
